import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useCreateDocxDraftMutation } from "../../../services/draftsService";
import { DocxDraftForm } from "./DocxDraftForm";
import { DocxDraftType } from "./DocxDraftType";

export function DocxDraftAddDialog({ title, open, onClose, onSuccessAdd, mode }) {
    const { t } = useTranslation();
    const { mutate: createDraft } = useCreateDocxDraftMutation({
        onSuccess: () => {
            toast.success(t("drafts.saveTemplate"));
            onClose();
            onSuccessAdd?.();
        },
    });

    const validateFileType = (file) => {
        const allowedExtensions = [".docx"];
        const fileName = file.name.toLowerCase();
        const fileExtension = fileName.substring(fileName.lastIndexOf("."));

        return allowedExtensions.includes(fileExtension);
    };

    const handleSubmit = (formData) => {
        if (formData.file && !validateFileType(formData.file)) {
            toast.error(t("drafts.validation.onlyDocxAllowed"));
            return;
        }

        createDraft({
            nr: formData.templateNumber,
            name: formData.templateName,
            description: formData.templateDescription,
            language: formData.templateLanguage,
            content: formData.file,
            active: true,
            is_offer: mode === DocxDraftType.OFFER,
            is_agreement: mode === DocxDraftType.AGREEMENT,
        });
    };

    const handleError = (errors) => {
        console.error("Form errors:", errors);
        toast.error("Proszę wypełnić wszystkie wymagane pola");
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle sx={{ textAlign: "center", fontWeight: "bold", position: "relative" }}>
                {t("drafts.offerTemplates.addTemplate").toUpperCase()}
                <IconButton
                    aria-label={t("close") || "Close"}
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DocxDraftForm
                    onSubmit={handleSubmit}
                    onError={handleError}
                    submitBtnText={t("drafts.saveTemplate")}
                    showFileUpload={true}
                />
            </DialogContent>
        </Dialog>
    );
}
